export function pickTransferToken(currentUser) {
  if (!currentUser || typeof currentUser !== 'object') {
    return undefined;
  }
  return (
    currentUser.accessToken ??
    currentUser.token ??
    currentUser.authToken ??
    currentUser.bearerToken
  );
}

export function buildSdkSetupHandoffPayload({
  productId,
  currentUser,
  android,
  web,
  ios,
}) {
  const token = pickTransferToken(currentUser);
  return {
    version: 1,
    source: 'intrack-dashboard',
    dashboardOrigin:
      typeof window !== 'undefined' ? window.location.origin : '',
    productId,
    sdk: {
      android: {
        name: android?.name,
        androidKey: android?.androidKey,
        licenceCode: android?.licenceCode,
      },
      web: {
        name: web?.name,
        webKey: web?.webKey,
        webPublicKey: web?.webPublicKey,
        licenceCode: web?.licenceCode,
      },
      ios: {
        name: ios?.name,
        iosKey: ios?.iosKey,
        licenceCode: ios?.licenceCode,
      },
    },
    user: currentUser
      ? {
          userId: currentUser.userId,
          email: currentUser.email,
        }
      : undefined,
    ...(token ? { token } : {}),
  };
}
